export { default } from './Card';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Card/index.jsx